import { createSelector } from "reselect"
import { get, chain, compact, map, find } from "lodash"
import { getSortedContentSets } from "selectors/contentSets"
import { getIsOpPro } from "modules/account-root/selectors"

export const getDecompositionType = state => get(state, "modules.optimizationScorecard.decompositionType")

export const getDecompositionTypes = createSelector(
  [getSortedContentSets, getIsOpPro],
  (contentSets, isOpPro) => {
    return compact([
      !isOpPro && {
        id: "risk",
        label: "Risk Decomposition (%)",
        order: 0,
        groupId: "model",
        groupLabel: "Risk Model",
      },
      {
        id: "exposure",
        label: "Exposure",
        order: 1,
        groupId: "model",
        groupLabel: "Risk Model",
      },
      !isOpPro && {
        id: "predictedFactorSensitivity",
        label: "Predicted Factor Sensitivity (%)",
        order: 3,
        groupId: "factorSensitivity",
        groupLabel: "Factor Sensitivity",
      },
      {
        id: "historicalFactorSensitivity",
        label: "Historical Factor Sensitivity (%)",
        order: 4,
        groupId: "factorSensitivity",
        groupLabel: "Factor Sensitivity",
      },
      ...map(contentSets, ({ escapedId, name }, i) => ({
        id: escapedId,
        label: name,
        groupId: "contentSet",
        groupLabel: "Content Sets",
        order: i + 5,
      })),
    ])
  },
)

export const getSelectedDecompositionTypeName = createSelector(
  [getDecompositionTypes, getDecompositionType],
  (types, selected) => chain(types)
    .find(({ id }) => id === selected)
    .get("label")
    .value(),
)

export const getSelectedContentSet = createSelector(
  [getSortedContentSets, getDecompositionType],
  (contentSets, selected) => find(contentSets, ({ escapedId }) => escapedId === selected),
)

export const getSelectedContentSetId = createSelector(
  [getSelectedContentSet],
  (contentSet) => get(contentSet, "escapedId"),
)
